/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemSchema } from './itemSchema';

export const paginationDocumentItemSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(itemSchema);
  },
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
